var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3431_56164)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 72,
    r: 60,
    fill: "#38879F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9999 50.2051C63.991 50.2051 54.2051 59.991 54.2051 71.9999C54.2051 84.0089 63.991 93.7948 75.9999 93.7948C88.0089 93.7948 97.7948 84.0089 97.7948 71.9999C97.7948 59.991 88.0089 50.2051 75.9999 50.2051ZM74.3653 63.282C74.3653 62.3884 75.1064 61.6474 75.9999 61.6474C76.8935 61.6474 77.6346 62.3884 77.6346 63.282V74.1794C77.6346 75.073 76.8935 75.8141 75.9999 75.8141C75.1064 75.8141 74.3653 75.073 74.3653 74.1794V63.282ZM78.0051 81.5461C77.8961 81.8294 77.7435 82.0474 77.5474 82.2653C77.3294 82.4615 77.0897 82.614 76.8282 82.723C76.5666 82.832 76.2833 82.8974 75.9999 82.8974C75.7166 82.8974 75.4333 82.832 75.1717 82.723C74.9102 82.614 74.6705 82.4615 74.4525 82.2653C74.2564 82.0474 74.1038 81.8294 73.9948 81.5461C73.8858 81.2846 73.8205 81.0012 73.8205 80.7179C73.8205 80.4346 73.8858 80.1512 73.9948 79.8897C74.1038 79.6282 74.2564 79.3884 74.4525 79.1705C74.6705 78.9743 74.9102 78.8217 75.1717 78.7128C75.6948 78.4948 76.3051 78.4948 76.8282 78.7128C77.0897 78.8217 77.3294 78.9743 77.5474 79.1705C77.7435 79.3884 77.8961 79.6282 78.0051 79.8897C78.114 80.1512 78.1794 80.4346 78.1794 80.7179C78.1794 81.0012 78.114 81.2846 78.0051 81.5461Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3431_56164",
    x: 0,
    y: 0,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3431_56164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3431_56164",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalConfirm);
export default __webpack_public_path__ + "static/media/modal-confirm.e7808652293cc662546c8cfb019d19f7.svg";
export { ForwardRef as ReactComponent };